import { cn } from '../../lib/cn';
import type { MessageQueueRow } from '../../enterpriseintegration/framework';

type Props = { queues?: MessageQueueRow[] };

export function MessageInfrastructurePanel({ queues = [] }: Props) {
  return (
    <div className="space-y-2">
      {queues.map((q) => (
        <div key={q.name} className="rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-sm font-medium">{q.name}</p>
              <p className="text-xs text-slate-500">{q.feature}</p>
            </div>
            <div className="text-right">
              <p className="text-sm font-semibold">{q.depth} msgs</p>
              <span className={cn(
                'text-xs font-medium',
                q.status === 'healthy' || q.status === 'active' ? 'text-success-600' :
                q.status === 'review' ? 'text-warning-600' : 'text-slate-500',
              )}>
                {q.status}
              </span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
